import React from 'react';
import PropTypes from 'prop-types';
import {
  Username,
  LogoBox,
  RightSideBox,
  SideMenuLogo,
  UserInfo,
  StyledLayoutHeader,
  UserRole
} from './BasicHeader.style';
import HeaderDropdown from '../HeaderDropdown/HeaderDropdown';
import { useApplicationStateValue } from '../../context/ApplicationContext';
import { supportedLanguages } from '../../i18n/init';
import { languages } from '../../i18n/langs';
import config from '../../util/config';

const BasicHeader = ({ children, user, menuItems, logo }) => {
  const { changeLanguage } = useApplicationStateValue();

  const changeLanguageHandler = (languageCode) => {
    changeLanguage(languageCode);
  };

  const openLogoLink = () => {
    window.open(config.LOGO_LINK, '_blank', 'noopener,noreferrer');
  };

  const appLanguages = supportedLanguages.map((language) => ({
    key: language,
    value: languages[language],
    callback: () => {
      changeLanguageHandler(language);
    }
  }));

  return (
    <StyledLayoutHeader height={config.HEADER_HEIGHT} className="container">
      <LogoBox onClick={openLogoLink}>
        <SideMenuLogo src={logo} alt="logo" />
      </LogoBox>
      <RightSideBox>
        {children}
        <UserInfo>
          <Username>
            {user.firstName}
            {' '}
            {user.lastName}
          </Username>
          <UserRole>{user.username}</UserRole>
        </UserInfo>
        <HeaderDropdown
          user={user}
          menuItems={menuItems}
          languages={appLanguages}
          changeLanguageHandler={changeLanguageHandler}
        />
      </RightSideBox>
    </StyledLayoutHeader>
  );
};

BasicHeader.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    username: PropTypes.string,
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  }).isRequired,
  logo: PropTypes.string.isRequired
};

export default BasicHeader;
